import { useEffect, useState } from 'react'

import { StyleSheet, View } from 'react-native'
import { ActivityIndicator, Text, useTheme } from 'react-native-paper'

interface LoadingIndicatorProps {
    message?: string
}

export function LoadingIndicator({ message = 'Loading…' }: LoadingIndicatorProps) {
    const [show, setShow] = useState(false)
    const theme = useTheme()
    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(true)
        }, 100)

        return () => clearTimeout(timer)
    }, [])

    if (!show) {
        return null
    }

    return (
        <View style={[styles.container, { backgroundColor: theme.colors.background }]}>
            <ActivityIndicator size="large" />
            <Text style={styles.text}>{message}</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 16,
        gap: 16,
        alignItems: 'center',
        justifyContent: 'center',
    },
    text: {
        textAlign: 'center',
    },
})
